import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { E3TimeSeriesEdit } from "./edit";
import { E3TimeSeriesNew } from "./new";
import { E3TimeSeriesTable } from "./table";

export default function E3TimeSeries() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Valorisation");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<E3TimeSeriesEdit />} />
      <Route index element={<E3TimeSeriesTable />} />
      <Route path="/new" element={<E3TimeSeriesNew />} />
    </Routes>
  );
}
